var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorPick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.2427,
    y: 1.63582,
    width: 3,
    height: 15,
    rx: 1.5,
    transform: "rotate(45 12.2427 1.63582)",
    fill: "white",
    stroke: "#190D1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8285 2.34292C11.6095 1.56188 12.8758 1.56188 13.6569 2.34292C14.4379 3.12397 14.4379 4.3903 13.6569 5.17135L11.5356 7.29267L8.70714 4.46424L10.8285 2.34292Z",
    fill: "#190D1A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3.75684,
    width: 6,
    height: 1,
    rx: 0.5,
    transform: "rotate(45 8 3.75684)",
    fill: "#190D1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPick);
export default __webpack_public_path__ + "static/media/ColorPick.3744948155f764e4206a43ce90abf025.svg";
export { ForwardRef as ReactComponent };